var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"page-body",attrs:{"fluid":""}},[_vm._v(" Customer Management Root ")])}
var staticRenderFns = []

export { render, staticRenderFns }